import React from "react";

import { Section } from "../ui/atoms/section";
import { useTranslation } from "react-i18next";
import { createUuid } from "../utils/uuid";
import sizes from "../ui/sizes.scss";
import { ListMotionSensors } from "../ui/molecules/list-motion-sensors";
import { FusionLayout } from "@/parts/fusion-layout";
import { observer } from "mobx-react";

export const PageMotionSensors = observer((): JSX.Element => {
    const { t } = useTranslation();
    return (
        <FusionLayout breadcrumb={t("page.motionSensors.title")} classic>
            <Section fill>
                <ListMotionSensors
                    listStateId={createUuid()}
                    maxHeight={`${sizes.listMaxHeight}`}
                />
            </Section>
        </FusionLayout>
    );
});
